import React, { Component } from 'react'
import { CancelOrder, ListMyOrders, Reorder } from '../../network/profile.network';
import { DeleteFilled, EditFilled, ExclamationCircleOutlined } from "@ant-design/icons";
import "./MyOrder.scss"
import { message, Modal, Select, Spin, Result, Button  } from 'antd';
import OrderTracking from '../OrderTracking/OrderTracking';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
const { confirm } = Modal; 
class MyOrder extends Component {

    state = {
        isLoading : false,
        showOrderDetails : false,
        orderList : null,
        orderTracking : null,
        originalOrder : null,
    }

    componentDidMount() {
        this.setState({isLoading  :true}) 
        console.log(this.props)
        ListMyOrders((res) => {
            // console.log(res.data.data); 
            this.setState({orderList : res.data.data, isLoading  :false}, () => {
                if(this.props.match.params.orderID){
                  const orderTrack = res.data.data.tracingOrders.find(order => order.id === +this.props.match.params.orderID)
                //   console.log(orderTrack)
                  this.setState({orderTracking : orderTrack})  
                }
            })
        }, (error) => {
            this.setState({isLoading  :false})
            console.log(error);
        })
    }

    showOrderList = () => {
        this.setState({orderTracking : null, showOrderDetails : false})  
    }

    handelCancelOrder = (orderId) => {
        confirm({ 
            title: this.props.localization.Dodeletetheseorder[this.props.currentLang],
            icon: <ExclamationCircleOutlined />,
            okText : this.props.localization.OK[this.props.currentLang],
            cancelText : this.props.localization.Cancel[this.props.currentLang],
            onOk : () => {
                let body = new FormData();
                body.append("orderId", orderId); 
                CancelOrder(
                  body, 
                  (res) => {
                    console.log(res) 
                    if(res.data.code === 200){ 
                      message.success(res.data.message); 
                      ListMyOrders((res) => {
                        this.setState({isLoading  :true}) 
                        console.log(res.data.data); 
                        this.setState({orderList : res.data.data, isLoading  :false, orderTracking : null, showOrderDetails : false})
                    }, (error) => {
                        this.setState({isLoading  :false}) 
                        console.log(error);
                    })
                    } 
                  },
                  (error) => {
                    console.log(error);  
                    // this.setState({btnLoading : false})
                  }
                );
            },
            onCancel() {
              console.log('Cancel');
            },
          });
    }

    handelReorder = (orderId) => {
        console.log(orderId); 
        confirm({ 
            title: this.props.localization.reorderheseorder[this.props.currentLang],
            icon: <ExclamationCircleOutlined />,
            okText : this.props.localization.OK[this.props.currentLang],
            cancelText : this.props.localization.Cancel[this.props.currentLang],
            onOk : () => {
                let body = new FormData();
                body.append("orderId", orderId); 
                Reorder(
                  body, 
                  (res) => {
                    console.log(res) 
                    if(res.data.code === 200){ 
                      message.success(res.data.message); 
                      ListMyOrders((res) => {
                        this.setState({isLoading  :true}) 
                        this.setState({orderList : res.data.data, isLoading  :false, orderTracking : null, showOrderDetails : false}, () => {
                            this.props.history.push("/cart"); 
                        })
                    }, (error) => {
                        this.setState({isLoading  :false})  
                        console.log(error);
                    })
                    } 
                  },
                  (error) => {
                    console.log(error);  
                    // this.setState({btnLoading : false})
                  }
                );
            },
            onCancel() {
              console.log('Cancel');
            },
          });
    }

    handelFilterOrder = (val) => {
        console.log(val);
        this.setState({isLoading : true})
        if(this.state.originalOrder === null){
            this.setState({originalOrder : this.state.orderList}, () => {
                switch (val) {
                    case "All":
                        this.setState({orderList : this.state.originalOrder,  originalOrder : null})
                        break;
                    case "Delivered":
                        // console.log(this.state); 
                        // console.log(this.state.originalOrder); 
                        // console.log(this.state.originalOrder.deliveredOrders); 
                        this.setState({orderList : { deliveredOrders : this.state.originalOrder?.deliveredOrders ? [...this.state.originalOrder?.deliveredOrders] : []  }})  
                        break;
                        case "Canceled":
                        this.setState({orderList : { cancelledOrders : this.state.originalOrder?.cancelledOrders ?  [...this.state.originalOrder?.cancelledOrders] : []} })
                        break;
                        case "Subscribed": 
                        this.setState({orderList : { subscribedOrders : this.state.originalOrder?.subscribedOrders ?  [...this.state.originalOrder?.subscribedOrders] : []} }) 
                        break;
                    default:
                        break;
                }
            })
        }else{
            switch (val) {
                case "All":
                    this.setState({orderList : this.state.originalOrder,  originalOrder : null})
                    break;
                case "Delivered":
                    // console.log(this.state); 
                    // console.log(this.state.originalOrder);  
                    // console.log(this.state.originalOrder.deliveredOrders); 
                    this.setState({orderList : { deliveredOrders : this.state.originalOrder?.deliveredOrders ? [...this.state.originalOrder?.deliveredOrders] : []  }})   
                    break;
                    case "Canceled":
                        this.setState({orderList : { cancelledOrders : this.state.originalOrder?.cancelledOrders ?  [...this.state.originalOrder?.cancelledOrders] : []} })
                    break;
                    case "Subscribed": 
                    this.setState({orderList : { subscribedOrders : this.state.originalOrder?.subscribedOrders ?  [...this.state.originalOrder?.subscribedOrders] : []} }) 
                    break;
                default:
                    break;
            }
        }
    this.setState({isLoading : false}) 
    }

    
    render() {
        const {orderList, orderTracking, isLoading, showOrderDetails} = this.state;
        const {localization, currentLang} = this.props;
        return (
            <>
            <Spin spinning={isLoading}>
            {orderTracking ?  
                <OrderTracking 
                showOrderList={this.showOrderList} 
                handelCancelOrder={(orderId) => this.handelCancelOrder(orderId)} 
                handelReorder={(orderId) => this.handelReorder(orderId)} 
                localization={localization} 
                currentLang={currentLang} 
                orderData={orderTracking} 
                showOrderDetails={showOrderDetails}
                /> 
            :
            (<div className="user-order-wrapper">
                {
                    orderList?.allOrders?.length === 0 &&
                    orderList?.cancelledOrders?.length === 0 &&
                    orderList?.deliveredOrders?.length === 0 && 
                    orderList?.subscribedOrders?.length === 0 &&
                    orderList?.tracingOrders?.length === 0 ? 
                    <Result
                        status="404"
                        title=""
                        subTitle={localization.sorrynoorder[currentLang]} 
                        extra={ <Button type="primary" size="large"> 
                        <Link to="/">{localization.BackToHome[currentLang]}</Link> 
                        </Button>}
                    /> : 
                <>
                <div className="user-order-type"> 
                <div className="user-order--header">
                    {orderList?.tracingOrders?.length > 0 && 
                    <p>
                    {localization.Onprocessorders[currentLang]}
                    </p> 
                    }
                    <Select dropdownClassName="order-dropdown-holder" defaultValue="All" style={{ width: 130 }} onChange={(val) => this.handelFilterOrder(val) }>
                        <Select.Option value="All">{localization.Allorders[currentLang]}</Select.Option>
                        <Select.Option value="Delivered">{localization.Delivered[currentLang]}</Select.Option>
                        <Select.Option value="Canceled">{localization.Canceled[currentLang]} </Select.Option> 
                        <Select.Option value="Subscribed">{localization.Subscribed[currentLang]}</Select.Option> 
                    </Select> 
                </div>
                {orderList?.tracingOrders?.map(order =>
                <div className="process-order-card" key={order.id}>
                    <div className="process-order-info">
                        <div className="process-order-number">
                            <p className="order-title">{localization.OrderID[currentLang]}  :</p> 
                            <p className="order-num">#{order.id}</p>  
                            <p className="order-status">{" - " + order.statuses.find(status => status.value === 2).name || ""}</p>   
                            {order.subscription && <p className="order-status">{"- " + localization.Subscribed[currentLang] }</p>} 
                        </div>
                        <time>{order.creationDate}</time>  
                    </div>
                    <div className="process-order-action">
                        <p className="track-order" onClick={() => {
                            this.setState({orderTracking : order}) 
                        }}>{localization.Trackorder[currentLang]} </p>   
                        <p className="cancel-order" onClick={() => this.handelCancelOrder(order.id)}>{localization.Cancelorder[currentLang]}</p>   
                    </div>
                </div> )}
                </div>

                {<div className="user-order-type user-order-type-prev">
                <div className="user-order--header"> 
                    { orderList?.deliveredOrders?.length > 0 && <p> 
                    {localization.YourPreviousorders[currentLang]} 
                    </p>} 
                </div>
                { orderList?.cancelledOrders?.length > 0 && orderList?.cancelledOrders?.map(order =>
                <div className="process-order-card" onClick={() => {
                    this.setState({orderTracking : order, showOrderDetails : true}) 
                }} key={order.id}> 
                    <div className="process-order-info">
                        <div className="process-order-number">
                            <p className="order-title">{localization.OrderID[currentLang]}  :</p> 
                            <p className="order-num">#{order.id}</p>  
                            <p className="order-status" style={{color : "#fe5252" }}>- {localization.Canceled[currentLang]}</p>
                            {order.subscription && <p className="order-status">{" - " + localization.Subscribed[currentLang]}</p>}
                        </div>
                        <time>{order.creationDate}</time>  
                    </div>
                </div>)}
                { orderList?.deliveredOrders?.length > 0 && orderList?.deliveredOrders?.map(order =>  
                <div className="process-order-card" onClick={() => {
                    this.setState({orderTracking : order, showOrderDetails : true}) 
                }} key={order.id}> 
                    <div className="process-order-info">
                        <div className="process-order-number"> 
                            <p className="order-title">{localization.OrderID[currentLang]}  :</p> 
                            <p className="order-num">#{order.id}</p>  
                            <p className="order-status" style={{color : "#00b181" }}>- {localization.Delivered[currentLang]}</p> 
                            {order.subscription && <p className="order-status">{" - " + localization.Subscribed[currentLang]}</p>} 
                        </div>
                        <time>{order.creationDate}</time>  
                    </div>
                </div>)}
                </div>}

                { orderList?.subscribedOrders?.length > 0 && <div className="user-order-type user-order-type-prev">
                <div className="user-order--header">
                    <p>
                    {localization.Yoursubscribeorders[currentLang]}  
                    </p>
                </div>
                {orderList?.subscribedOrders?.map(order =>  
                <div className="process-order-card" onClick={() => {
                    this.setState({orderTracking : order, showOrderDetails : true}) 
                }} key={order.id}> 
                    <div className="process-order-info">
                        <div className="process-order-number"> 
                            <p className="order-title">{localization.OrderID[currentLang]}  :</p> 
                            <p className="order-num">#{order.id}</p>   
                            <p className="order-status">- {order.orderStatus.name}</p>   
                            {order.subscription && <p className="order-status">{" - " + localization.Subscribed[currentLang]}</p>} 
                        </div>
                        <time>{order.creationDate}</time>   
                    </div>
                </div>)}
                </div>
                }
                </>
                }
            </div>)
            }
            </Spin> 
            </>
        )
    }
}

const MyOrderWithRouter = withRouter(MyOrder); 
const mapStateToProps = (state) => ({
  currentLang : state.user.currentLang,
});

export default connect(mapStateToProps)(MyOrderWithRouter);
